import * as React from "react";
import { toINR } from "../../../../service/numberFormat";
import { marginMcxHeading } from "../../marginConstants";
import { ISortProps } from "../../../../types/components/margin/marginTypes";
import MarginSort from "../../generic/marginSort";
import NoDataContainer from "../../../../generic/noDataContainer";

export interface IMarginMcxTableDskProps {
	tableData: Array<any>;
	filteredData: Array<any>;
	numOfRows: number;
	sortProps: ISortProps;
	setTableData: (tableData: Array<any>) => void;
}

const MarginMcxTableDsk: React.FC<IMarginMcxTableDskProps> = props => {
	const [openRowIndex, setOpenRowIndex] = React.useState(-1); // -1 if no row is open, otherwise row-index

	function toggleAccordian(index: number) {
		if (openRowIndex === index) {
			// if clicked on open tab, then close it
			setOpenRowIndex(-1);
		} else {
			// otherwise open the tab
			setOpenRowIndex(index);
		}
	}

	return (
		<div className="mrgn_mcx_tbl table">
			<ul className="hdr_row">
				<li className="tr">
					<div className="td trdSym">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="trdSym"
								onSort={props.sortProps.onSort}
								colName={marginMcxHeading.trdSym}
							/>
						</span>
					</div>
					<div className="td LotSize">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="LotSize"
								onSort={props.sortProps.onSort}
								colName={marginMcxHeading.lotSize}
							/>
						</span>
					</div>
					<div className="td SPANMargin right">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="SPANMargin"
								onSort={props.sortProps.onSort}
								colName={marginMcxHeading.spanMargin}
							/>
						</span>
					</div>
					<div className="td ExpMargin right">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="ExpMargin"
								onSort={props.sortProps.onSort}
								colName={marginMcxHeading.expMargin}
							/>
						</span>
					</div>
					<div className="td SpreadBenefit right">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="SpreadBenefit"
								onSort={props.sortProps.onSort}
								colName={marginMcxHeading.spreadBenefit}
							/>
						</span>
					</div>
					<div className="td AdditionalMargin right">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="AdditionalMargin"
								onSort={props.sortProps.onSort}
								colName={marginMcxHeading.additionalMargin}
							/>
						</span>
					</div>
					<div className="td TotalMargin right">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="TotalMargin"
								onSort={props.sortProps.onSort}
								colName={marginMcxHeading.totalMargin}
							/>
						</span>
					</div>
				</li>
			</ul>

			{props.tableData.length ? (
				<ul className="mrgn_scrl_cont data_rows">
					{props.tableData.slice(0, props.numOfRows).map((row, index) => (
						<React.Fragment key={index}>
							<li className={"tr acc_label " + (openRowIndex === index ? "open" : "")} onClick={() => toggleAccordian(index)}>
								<div className="td trdSym robotoM">
									<span dangerouslySetInnerHTML={{ __html: row.trdSym }}></span>
								</div>
								<div className="td LotSize">{toINR(row.LotSize)}</div>
								<div className="td SPANMargin right">{toINR(row.SPANMargin)}</div>
								<div className="td ExpMargin right">{toINR(row.ExpMargin)}</div>
								<div className="td SpreadBenefit right">{toINR(row.SpreadBenefit)}</div>
								<div className="td AdditionalMargin right">{toINR(row.AdditionalMargin)}</div>
								<div className="td TotalMargin right">{toINR(row.TotalMargin)}</div>
							</li>
							<li className={"tr acc_panel " + (openRowIndex === index ? "open" : "close")} onClick={() => toggleAccordian(index)}>
								<div className="td">
									<div className="acc_content">
										<div className="acc_row acc_row1 ib">
											<div className="acc_col">
												<span className="label">Special Margin</span>
												<span className="value">{toINR(row.SpecialMargin, 2)}</span>
											</div>
											<div className="acc_col">
												<span className="label">Delivery Margin</span>
												<span className="value">{toINR(row.DeliveryMargin, 2)}</span>
											</div>
										</div>
										<div className="acc_row acc_row2 ib">
											<div className="acc_col">
												<span className="label">Tender Margin</span>
												<span className="value">{toINR(row.TenderMargin, 2)}</span>
											</div>
											<div className="acc_col">
												<span className="label">Additional PreExpiry</span>
												<span className="value">{toINR(row.AddtPreExpMargin, 2)}</span>
											</div>
										</div>
									</div>
								</div>
							</li>
						</React.Fragment>
					))}
				</ul>
			) : (
				<NoDataContainer txtHeading="No results found" />
			)}
		</div>
	);
};

export default MarginMcxTableDsk;
